import { render, staticRenderFns } from "./PanelQrCard.vue?vue&type=template&id=20c6de62&scoped=true&"
import script from "./PanelQrCard.vue?vue&type=script&lang=js&"
export * from "./PanelQrCard.vue?vue&type=script&lang=js&"
import style0 from "./PanelQrCard.vue?vue&type=style&index=0&id=20c6de62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6de62",
  null
  
)

export default component.exports